import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerformanceComponent } from './performance.component';
import { ChartModule } from 'primeng/chart';
import { PanelModule } from 'primeng/panel';
import { NgxChronometerModule } from 'ngx-chronometer';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';



@NgModule({
  declarations: [PerformanceComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ChartModule,
    PanelModule,
    NgxChronometerModule,
    OverlayPanelModule,
    TabViewModule,
    CalendarModule,
    DropdownModule
  ]
})
export class PerformanceModule { }
